module.exports = "<exa-weather-comparison-section [customer]=\"customer.selected$ | async\"></exa-weather-comparison-section>\r\n"